<div class="panel-body">
  <div class="row">
    <div class="col-xs-12">
      <div class="checkbox">
        <label>
          <input ng-change="recomendacaoSemeadura.changeCobertura(recomendacaoSemeadura.data.cobertura)" ng-disabled="recomendacaoSemeadura.data.id" ng-model="recomendacaoSemeadura.data.cobertura" type="checkbox"> Semeadura de Cobertura
        </label>
        <i
          class="icon-info text-muted"
          uib-tooltip="Quando marcada a opção Semeadura de Cobertura a recomendação considera a dose/ha e não a densidade de sementes por ha. Não é possível alterar na edição"
        ></i>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 form-group">
      <label for="propriedade">Propriedade</label>
      <select ng-disabled="recomendacaoSemeadura.data.glebas.length" name="propriedade" ng-model="recomendacaoSemeadura.data.propriedade" id="propriedade" class="form-control" ng-options="propriedade.descricao for propriedade in recomendacaoSemeadura.propriedades track by propriedade.id" ng-change="recomendacaoSemeadura.getPeriodosByEmpreedimentos()">
        <option value="">Selecione</option>
      </select>
    </div>
    <div class="col-md-4 form-group">
      <label for="cultura" class="control-label">Cultura</label>
      <select ng-disabled="recomendacaoSemeadura.data.glebas.length" name="cultura" ng-change="recomendacaoSemeadura.changeCultura(recomendacaoSemeadura.data.cultura)" ng-model="recomendacaoSemeadura.data.cultura" id="cultura" class="form-control" ng-options="cultura.descricao for cultura in recomendacaoSemeadura.culturas track by cultura.id" required>
        <option value="">Selecione</option>
      </select>
    </div>
    <div class="col-md-2 form-group">
      <label for="safra" class="control-label">Safra</label>
      <select name="safra" ng-model="recomendacaoSemeadura.data.safra" id="safra" class="form-control" ng-options="safra.descricao for safra in recomendacaoSemeadura.safras track by safra.id" required ng-change="recomendacaoSemeadura.getPeriodosByEmpreedimentos()">
        <option value="">Selecione</option>
      </select>
    </div>
    <div class="col-md-2 form-group">
      <label for="periodo" class="control-label">Período</label>
      <select name="periodo" ng-model="recomendacaoSemeadura.data.periodo" id="periodo" class="form-control" ng-options="periodo.descricao for periodo in recomendacaoSemeadura.empreendimentos_periodos track by periodo.codigo" required>
        <option value="">Selecione</option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-4 form-group">
      <label for="rendimento_minimo" class="control-label">Rendimento Operacional Mín.</label>
      <div class="input-group">
        <input type="number" name="rendimento_minimo" ng-model="recomendacaoSemeadura.data.rendimento_minimo" id="rendimento_minimo" class="form-control" auto-step required min="0" ng-change="recomendacaoSemeadura.calcDuracao('all')">
        <span class="input-group-addon">ha/dia</span>
      </div>
    </div>
    <div class="col-xs-4 form-group">
      <label for="rendimento_maximo" class="control-label">Rendimento Operacional Máx.</label>
      <div class="input-group">
        <input type="number" name="rendimento_maximo" ng-model="recomendacaoSemeadura.data.rendimento_maximo" id="rendimento_maximo" class="form-control" auto-step required min="0" ng-change="recomendacaoSemeadura.calcDuracao('all')">
        <span class="input-group-addon">ha/dia</span>
      </div>
    </div>
    <div class="col-xs-4 form-group">
      <label for="espacamento" class="control-label">Espaçamento</label>
      <div class="input-group">
        <input ng-disabled="recomendacaoSemeadura.data.cobertura" type="number" name="espacamento" ng-model="recomendacaoSemeadura.data.espacamento" id="espacamento" class="form-control" auto-step required min="0" ng-change="recomendacaoSemeadura.calcRegulagem('all')">
        <span class="input-group-addon">m</span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-4 form-group">
      <label for="quantidade" class="control-label">Área de Remontes</label>
      <div class="input-group">
        <input ng-disabled="recomendacaoSemeadura.data.cobertura" type="number" name="area_remontes" ng-model="recomendacaoSemeadura.data.area_remontes" id="area_remontes" class="form-control" auto-step required min="0" max="100" ng-change="recomendacaoSemeadura.calcDensidade('all')">
        <span class="input-group-addon">%</span>
      </div>
    </div>
    <div class="col-xs-4 form-group">
      <label for="densidade" class="control-label">Correção de densidade (Remonte)</label>
      <div class="input-group">
        <input ng-disabled="recomendacaoSemeadura.data.cobertura" type="number" name="densidade" ng-model="recomendacaoSemeadura.data.densidade" id="densidade" class="form-control" auto-step required min="0" max="100" ng-change="recomendacaoSemeadura.calcDensidade('all')">
        <span class="input-group-addon">%</span>
      </div>
    </div>
    <div class="col-xs-4 form-group">
      <label for="quantidade" class="control-label">Correção de quantidade (Úmidade do Solo)</label>
      <div class="input-group">
        <input ng-disabled="recomendacaoSemeadura.data.cobertura" type="number" name="quantidade" ng-model="recomendacaoSemeadura.data.quantidade" id="quantidade" class="form-control" auto-step required min="0" max="100" ng-change="recomendacaoSemeadura.calcDensidade('all')">
        <span class="input-group-addon">%</span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-4 form-group">
      <label for="regulagem" class="control-label">Distribuição de regulagem para semente</label>
      <div class="input-group">
        <input ng-disabled="recomendacaoSemeadura.data.cobertura" type="number" name="regulagem" ng-model="recomendacaoSemeadura.data.regulagem" id="regulagem" class="form-control" auto-step required min="0"  ng-change="recomendacaoSemeadura.calcRegulagem('all')">
        <span class="input-group-addon">m</span>
      </div>
    </div>
    <div class="col-xs-4 form-group">
      <label for="regulagem_adubacao" class="control-label">Distribuição de regulagem para adubação</label>
      <div class="input-group">
        <input ng-disabled="recomendacaoSemeadura.data.cobertura" type="number" name="regulagem_adubacao" ng-model="recomendacaoSemeadura.data.regulagem_adubacao" id="regulagem_adubacao" class="form-control" auto-step required min="0"  ng-change="recomendacaoSemeadura.calcRegulagemAdubos()">
        <span class="input-group-addon">m</span>
      </div>
    </div>
    <div class="col-xs-4">
      <div class="checkbox">
        <label for="calculo_margem_seguranca" class="control-label">
          <input ng-disabled="recomendacaoSemeadura.data.cobertura" type="checkbox" id="calculo_margem_seguranca" ng-model="recomendacaoSemeadura.data.calculo_margem_seguranca">
          Cálculo com margem de segurança
        </label>
      </div>
      <p class="help-block">
        Se ativo, os valores em Regulagem, Regulagem Adubação e Qtd. exibirão uma variação de 3% para mais e para menos
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 form-group">
      <label for="observacao" class="control-label">Observação</label>
      <div class="input-group">
        <textarea class="form-control" id="observacao" ng-model="recomendacaoSemeadura.data.observacao" cols="500" rows="5"></textarea>
      </div>
    </div>
  </div>
</div>
